import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../../helper/Baseurl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import noCoursesImage from "../../assets/images/png/Search.png"; 
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; 
import { useTranslation } from "../../context/TranslationContext"; 

const MyborrowButton = () => {
   const { translations , language} = useTranslation(); 
    const isArabic = language === "ar";

  const [mybooks, setMyBooks] = useState([]);
  const [notificationShown, setNotificationShown] = useState(false);
  const [loading, setLoading] = useState(true);
   const [currentPage, setCurrentPage] = useState(1); 
   const coursesPerPage = 8;
   const indexOfLastCourse = currentPage * coursesPerPage;
   const indexOfFirstCourse = indexOfLastCourse - coursesPerPage;
   const currentCourses = mybooks.slice(indexOfFirstCourse, indexOfLastCourse);
   const totalPages = Math.ceil(mybooks.length / coursesPerPage);

   const handlePageChange = (pageNumber) => {
     setCurrentPage(pageNumber);
   };
  const showMyBooks = async () => {
    try {
      const response = await axios.get(baseurl + "my-book-borrows", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response.data && Array.isArray(response.data[0])) {
        return response.data[0]; 
      }
    } catch (error) {
      console.error("Error fetching my books:", error);
      return [];
    }
  };

  const showpicbooks = async (fileName) => {
    try {
      const imageUrl = `${baseurl}uploads/file/download/${fileName}`;
      return imageUrl;
    } catch (error) {
      console.error("Error fetching image:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
      const booksData = await showMyBooks();
      if (!booksData || booksData.length === 0) return;

      const updatedBooks = await Promise.all(
        booksData.map(async (order) => {
          const imageUrl = await showpicbooks(order.book.coverImageUrl);
          return {
            ...order.book,
            returnDate: order.returnDate, 
            coverImageUrl: imageUrl,
          };
        })
      );

      console.log("Updated books with images:", updatedBooks);
      setMyBooks(updatedBooks);
    } catch (error) {
      console.error("Error fetching  data", error);
    } finally {
      setLoading(false);
    }
    };
    fetchData();
  }, []);

  
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString("en-GB", options);
  };


  const isDatePast = (dateString) => {
    return new Date(dateString) < new Date();
  };


  const notifyPastReturnDate = () => {
    toast.warning(translations.borrowedBooksWarning, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {

    if (!notificationShown) {
      const hasOverdueBooks = mybooks.some((book) =>
        isDatePast(book.returnDate)
      );
      if (hasOverdueBooks) {
        notifyPastReturnDate();
        setNotificationShown(true); 
      }
    }
  }, [mybooks, notificationShown]);


  const rows = [];
 for (let i = 0; i < currentCourses.length; i += 4) {
   rows.push(currentCourses.slice(i, i + 4));
 }

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (mybooks.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center p-4 mt-[-10%]">
        <img
          src={noCoursesImage}
          alt="No courses available"
          className="w-60 h-60 object-cover mb-10"
        />
        <p className="text-lg text-gray-700 mt-0">
{translations.noBorrowedBooks}
        </p>
      </div>
    );
  }
  return (
    <div className="p-4">
      <ToastContainer position="bottom-left" />
      {rows.map((row, index) => (
        <div key={index} className="flex flex-wrap -mx-2 mb-4">
          {row.map((book, idx) => (
            <div key={idx}  className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-2">
              <div className="bg-white shadow-lg rounded-lg p-4 flex items-center h-full">
                <img
                  src={book.coverImageUrl}
                  alt={book.title}
                  className="w-24 h-32 object-cover rounded-lg ml-4  mr-5 flex-shrink-0"
                />
                <div
                  className="flex-1"
                  style={{ fontFamily: "Tajwal, sans-serif" }}
                >
                  <h3 className="text-lg font-bold mb-2">{book.title}</h3>
                  <p className="text-sm text-gray-500 mb-3">
                    {book.description.length > 100
                      ? `${book.description.slice(0, 100)}...`
                      : book.description}
                  </p>
                  <p
                    className={`text-sm font-bold ${
                      isDatePast(book.returnDate)
                        ? "text-red-500"
                        : "text-gray-700"
                    }`}
                  >
                   {translations.returnDate} {formatDate(book.returnDate)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}

      {/* Pagination */}
      <div className="mt-4">
        <ul className="flex justify-center space-x-2 items-center">
          <li>
            <button
              className={`px-3 py-1 rounded-full ${
                currentPage > 1
                  ? "text-primary-blue"
                  : "text-gray-400 cursor-not-allowed"
              }`}
              onClick={() =>
                currentPage > 1 && handlePageChange(currentPage - 1)
              }
              disabled={currentPage === 1}
            >
             {isArabic ?    <FaArrowRight /> :    <FaArrowLeft />}
            </button>
          </li>
          {Array.from({ length: totalPages }, (_, index) => (
            <li key={index}>
              <button
                className={`px-3 py-1 rounded-full ${
                  currentPage === index + 1
                    ? "bg-primary-blue text-white"
                    : "text-gray-700"
                }`}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </button>
            </li>
          ))}
          <li>
            <button
              className={`px-3 py-1 rounded-full ${
                currentPage < totalPages
                  ? "text-primary-blue"
                  : "text-gray-400 cursor-not-allowed"
              }`}
              onClick={() =>
                currentPage < totalPages && handlePageChange(currentPage + 1)
              }
              disabled={currentPage === totalPages}
            >
              {isArabic ?      <FaArrowLeft />  :    <FaArrowRight />}
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MyborrowButton;
